<template>
	<div class="action-list">
		<div
			class="action-list-title"
			v-if="title"
			v-text="localize ? $t(title) : title"
		/>
		<div
			class="action-list-item"
			v-for="item in items"
			:key="item.id || item.label"
			:class="{
				[item.type || 'default']: true,
				disabled: item.disabled,
				'no-click': item.disabled || item.noClick,
			}"
			@click="item.onClick ? item.onClick($event) : $emit('select', item)"
		>
			<component
				:is="tagType(item)"
				:href="item.href"
				target="_blank"
				class="action-wrapper"
			>
				<slot name="item" :item="item">
					<div class="action-list-icon">
						<slot name="icon" :item="item">
							<component :is="item.icon" />
						</slot>
					</div>
					<div class="action-list-label">
						<slot name="label" :item="item">
							{{ localize ? $t(item.label) : item.label }}
						</slot>
					</div>
				</slot>
			</component>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ActionList',
	props: {
		title: String,
		items: Array,
		localize: { type: Boolean, default: null },
	},
	methods: {
		tagType(item) {
			if (item.href) return 'a'
			return 'div'
		},
	},
	emits: ['select'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.action-wrapper div {
	display: inline-block;
}

a {
	text-decoration: inherit;
	color: inherit;
}

.action-list {
	color: var(--neutral-800);
	font-size: 14px;
	font-family: Avenir-Roman;
	.action-list-title {
		font-size: 12px;
		margin-bottom: 16px;
	}
	.action-list-item {
		@include flex;
		margin-bottom: 16px;
		cursor: pointer;
		font-family: Avenir-Book;

		&:last-child {
			margin-bottom: 0;
		}
		&:hover:not(.disabled) {
			color: var(--blue-300);
		}
		&.danger {
			color: var(--red-200);
			&:hover:not(.disabled) {
				color: var(--red-300);
			}
		}
		&.primary {
			color: var(--blue-300);
		}
		&.no-click {
			cursor: default;
			pointer-events: none;
		}
		&.disabled {
			opacity: 0.4;
		}
		.action-list-icon {
			margin-right: 8px;
		}
	}
}
</style>
